(() => {
  const productCache = new Map();

  /* =======================================================
     BASIC HELPERS
     ======================================================= */

  function createElement(tag, className, text) {
    const element = document.createElement(tag);

    if (className) {
      element.className = className;
    }

    if (text !== undefined && text !== null) {
      element.textContent = text;
    }

    return element;
  }


  function safeImageUrl(value) {
    if (!value) {
      return '';
    }

    try {
      const url = new URL(value, window.location.origin);

      if (
        url.protocol !== 'https:' &&
        url.protocol !== 'http:'
      ) {
        return '';
      }

      return url.toString();
    } catch {
      return '';
    }
  }


  function reviewerInitials(name) {
    if (!name) {
      return '?';
    }

    return name
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }

function formatReviewCounts() {
  const formatter =
    new Intl.NumberFormat(
      'en-US'
    );


  document
    .querySelectorAll(
      '.aura-reviews-summary__count, .aura-reviews-products__count'
    )
    .forEach(element => {

      const text =
        element.textContent.trim();


      const match =
        text.match(
          /^([\d,]+)(.*)$/
        );


      if (!match) {
        return;
      }


      const number =
        Number(
          match[1].replace(
            /,/g,
            ''
          )
        );


      if (
        !Number.isFinite(number)
      ) {
        return;
      }


      element.textContent =
        `${formatter.format(number)}${match[2]}`;
    });
}

  function formatDate(value) {
    if (!value) {
      return '';
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return new Intl.DateTimeFormat(
      'en-US',
      {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }
    ).format(date);
  }


  /* =======================================================
     TEXT CASING
     ======================================================= */

  function titleCaseName(value) {
    if (!value) {
      return '';
    }

    return String(value)
      .trim()
      .split(/\s+/)
      .map(part => {
        /* Keep two-letter initial-style names such as MM. */
        if (/^[A-Z]{2}$/.test(part)) {
          return part;
        }

        return part
          .toLowerCase()
          .replace(
            /(^|[-'’])([a-z])/g,
            (match, separator, letter) =>
              separator + letter.toUpperCase()
          );
      })
      .join(' ');
  }


  function smartTitleCase(value) {
    if (!value) {
      return '';
    }

    /*
     * Connecting words remain lowercase unless they are:
     * - the first word of the title
     * - the final word of the title
     * - the first word after opening punctuation / a new segment
     */
    const minorWords = new Set([
      'a',
      'about',
      'after',
      'an',
      'and',
      'as',
      'at',
      'before',
      'between',
      'but',
      'by',
      'during',
      'for',
      'from',
      'if',
      'in',
      'into',
      'nor',
      'of',
      'off',
      'on',
      'or',
      'over',
      'per',
      'so',
      'than',
      'that',
      'the',
      'through',
      'to',
      'under',
      'until',
      'up',
      'via',
      'with',
      'within',
      'without',
      'yet'
    ]);

    /* Preserve genuine acronyms / brand-style terms. */
    const preservedTerms = new Map([
      ['ai', 'AI'],
      ['covid', 'COVID'],
      ['covid-19', 'COVID-19'],
      ['fda', 'FDA'],
      ['faq', 'FAQ'],
      ['hd', 'HD'],
      ['lcd', 'LCD'],
      ['uk', 'UK'],
      ['us', 'US'],
      ['usa', 'USA'],
      ['usb', 'USB'],
      ['wi-fi', 'Wi-Fi'],
      ['wifi', 'Wi-Fi']
    ]);

    const words = String(value)
      .trim()
      .split(/\s+/);

    return words
      .map((word, index) => {
        const previousWord = index > 0
          ? words[index - 1]
          : '';

        const leadingMatch = word.match(
          /^[\(\[\{“‘"']+/
        );

        const trailingMatch = word.match(
          /[\)\]\}”’"'.,!?;:]+$/
        );

        const leading = leadingMatch
          ? leadingMatch[0]
          : '';

        const trailing = trailingMatch
          ? trailingMatch[0]
          : '';

        const coreEnd = trailing
          ? word.length - trailing.length
          : word.length;

        const core = word.slice(
          leading.length,
          coreEnd
        );

        if (!core) {
          return word;
        }

        const lowerCore =
          core.toLowerCase();

        const startsNewSegment =
          index === 0 ||
          /^[\(\[\{“‘"']/.test(word) ||
          /[:.!?]$/.test(previousWord);

        const isLastWord =
          index === words.length - 1;

        let formattedCore =
          lowerCore;

        if (
          preservedTerms.has(lowerCore)
        ) {
          formattedCore =
            preservedTerms.get(lowerCore);

        } else if (
          minorWords.has(lowerCore) &&
          !startsNewSegment &&
          !isLastWord
        ) {
          formattedCore =
            lowerCore;

        } else {
          /*
           * Apostrophes are deliberately NOT treated
           * as new words.
           *
           * IT'S   -> It's
           * WE'RE  -> We're
           * BABY'S -> Baby's
           *
           * Hyphen/slash compounds are handled separately:
           *
           * mom-to-be -> Mom-to-Be
           */
          const parts =
            lowerCore.split(/([-/])/);

          formattedCore = parts
            .map((part, partIndex) => {
              if (
                part === '-' ||
                part === '/'
              ) {
                return part;
              }

              const isFirstPart =
                partIndex === 0;

              const isLastPart =
                partIndex ===
                parts.length - 1;

              if (
                minorWords.has(part) &&
                !isFirstPart &&
                !isLastPart
              ) {
                return part;
              }

              if (
                preservedTerms.has(part)
              ) {
                return preservedTerms.get(
                  part
                );
              }

              return part.replace(
                /^([a-z])/,
                letter =>
                  letter.toUpperCase()
              );
            })
            .join('');
        }

        return (
          leading +
          formattedCore +
          trailing
        );
      })
      .join(' ');
  }


  /* =======================================================
     STARS
     ======================================================= */

  function createStars(rating) {
    const stars = createElement(
      'div',
      'aura-api-review__stars'
    );

    stars.setAttribute(
      'aria-label',
      `${rating} out of 5 stars`
    );

    for (
      let star = 1;
      star <= 5;
      star += 1
    ) {
      const icon = createElement(
        'span',
        star <= rating
          ? 'aura-api-review__star aura-api-review__star--full'
          : 'aura-api-review__star aura-api-review__star--empty'
      );

      icon.setAttribute(
        'aria-hidden',
        'true'
      );

      stars.appendChild(icon);
    }

    return stars;
  }


  /* =======================================================
     VERIFIED BADGE
     ======================================================= */

function createVerifiedBadge(
    label = 'Verified Buyer'
  ) {
    const badge = createElement(
      'span',
      'aura-api-review__verified'
    );

    const icon =
      document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg'
      );

    icon.setAttribute(
      'viewBox',
      '0 0 24 24'
    );

    icon.setAttribute(
      'aria-hidden',
      'true'
    );

    icon.innerHTML = `
      <circle
        cx="12"
        cy="12"
        r="10"
      ></circle>

      <path
        d="M7.8 12.1L10.5 14.8L16.4 8.9"
      ></path>
    `;

    const text = createElement(
      'span',
      '',
      label
    );

    badge.appendChild(icon);
    badge.appendChild(text);

    return badge;
  }


  /* =======================================================
     AVATAR
     ======================================================= */

  function createAvatar(review) {
    const avatar = createElement(
      'div',
      'aura-api-review__avatar'
    );

    const reviewerName =
      titleCaseName(
        review?.reviewer?.name || ''
      );

    const imageUrl =
      safeImageUrl(
        review?.reviewer?.avatar_url
      );

    if (imageUrl) {
      const image =
        document.createElement('img');

      image.src = imageUrl;
      image.alt = reviewerName;
      image.loading = 'lazy';

      avatar.appendChild(image);

    } else {
      avatar.textContent =
        reviewerInitials(
          reviewerName
        );
    }

    return avatar;
  }


  /* =======================================================
     REVIEW MEDIA
     ======================================================= */

  function createMedia(review) {
    const pictures =
      Array.isArray(review.pictures)
        ? review.pictures
        : [];

    if (!pictures.length) {
      return null;
    }

    const media = createElement(
      'div',
      'aura-api-review__media'
    );

    media.classList.add(
      pictures.length === 1
        ? 'aura-api-review__media--single'
        : 'aura-api-review__media--multiple'
    );

    const visiblePictures =
      pictures.slice(0, 3);

    visiblePictures.forEach(
      (picture, index) => {
        const item = createElement(
          'div',
          'aura-api-review__media-item'
        );

        const image =
          document.createElement('img');

        image.src = safeImageUrl(
          picture.large ||
          picture.medium ||
          picture.original
        );

        image.alt = review.title
          ? smartTitleCase(
              review.title
            )
          : 'Customer review photo';

        image.loading = 'lazy';

        item.appendChild(image);

        if (
          index === 2 &&
          pictures.length > 3
        ) {
          const more = createElement(
            'span',
            'aura-api-review__media-more',
            `+${pictures.length - 3}`
          );

          item.appendChild(more);
        }

        media.appendChild(item);
      }
    );

    return media;
  }


  /* =======================================================
     SHOPIFY PRODUCT LOOKUP
     ======================================================= */

  async function getShopifyProduct(
    handle
  ) {
    if (!handle) {
      return null;
    }

    if (
      productCache.has(handle)
    ) {
      return productCache.get(
        handle
      );
    }

    const root =
      window.Shopify?.routes?.root ||
      '/';

    const request = fetch(
      `${root}products/${encodeURIComponent(handle)}.js`,
      {
        headers: {
          Accept:
            'application/json'
        }
      }
    )
      .then(response => {
        if (!response.ok) {
          throw new Error(
            'Product request failed'
          );
        }

        return response.json();
      })
      .catch(() => null);

    productCache.set(
      handle,
      request
    );

    return request;
  }


  /* =======================================================
     PRODUCT / SHOP REVIEW FOOTER
     ======================================================= */

  function createProductRow(review) {
    const handle =
      review?.product?.handle ||
      '';

    const rawTitle =
      review?.product?.title ||
      '';

    const normalizedTitle =
      rawTitle.toLowerCase();

    const isShopReview =
      !handle ||
      normalizedTitle.includes(
        'judge.me shop reviews'
      ) ||
      normalizedTitle.includes(
        'shop reviews'
      ) ||
      handle.includes(
        'judge-me-shop-reviews'
      ) ||
      handle.includes(
        'judgeme-shop-reviews'
      );

    if (isShopReview) {
      const row = createElement(
        'a',
        'aura-api-review__product aura-api-review__product--shop'
      );

      row.href =
        '/collections/all';

      row.setAttribute(
        'aria-label',
        'Shop all Aura Baby products'
      );

      const iconWrap = createElement(
        'span',
        'aura-api-review__product-image aura-api-review__shop-icon'
      );

      iconWrap.innerHTML = `
        <svg
          viewBox="0 0 48 48"
          aria-hidden="true"
        >
          <path
            d="M9 19H39L36.5 40H11.5L9 19Z"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          ></path>

          <path
            d="M15 19C15 13.5 18.7 9 24 9C29.3 9 33 13.5 33 19"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          ></path>

          <path
            d="M24 34S18 30.7 18 26.2C18 24.1 19.5 23 21.1 23C22.3 23 23.3 23.7 24 24.7C24.7 23.7 25.7 23 26.9 23C28.5 23 30 24.1 30 26.2C30 30.7 24 34 24 34Z"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linejoin="round"
          ></path>
        </svg>
      `;

      const title = createElement(
        'span',
        'aura-api-review__product-title',
        'Aura Baby Shopping Experience'
      );

      row.appendChild(iconWrap);
      row.appendChild(title);

      return row;
    }

    const row = createElement(
      'a',
      'aura-api-review__product'
    );

    row.href =
      `/products/${encodeURIComponent(handle)}`;

    const imageWrap =
      createElement(
        'span',
        'aura-api-review__product-image'
      );

    const title = createElement(
      'span',
      'aura-api-review__product-title',
      rawTitle ||
        'View product'
    );

    row.appendChild(imageWrap);
    row.appendChild(title);

    getShopifyProduct(handle)
      .then(product => {
        if (!product) {
          return;
        }

        if (product.title) {
          title.textContent =
            product.title;
        }

        const source = safeImageUrl(
          product.featured_image ||
          product.images?.[0]
        );

        if (!source) {
          return;
        }

        const image =
          document.createElement('img');

        image.src =
          source;

        image.alt =
          product.title || '';

        image.loading =
          'lazy';

        imageWrap.replaceChildren(
          image
        );
      });

    return row;
  }


  /* =======================================================
     FULL REVIEW MODAL
     ======================================================= */

  let auraReviewLastFocus =
    null;


  function createReviewModal() {
    let modal =
      document.querySelector(
        '[data-aura-review-modal]'
      );

    if (modal) {
      return modal;
    }

    modal = createElement(
      'div',
      'aura-review-modal'
    );

    modal.hidden =
      true;

    modal.setAttribute(
      'data-aura-review-modal',
      ''
    );

    modal.innerHTML = `
      <div
        class="aura-review-modal__backdrop"
        data-aura-review-modal-close
      ></div>

      <div
        class="aura-review-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="AuraReviewModalTitle"
        tabindex="-1"
      >
        <button
          type="button"
          class="aura-review-modal__close"
          data-aura-review-modal-close
          aria-label="Close review"
        >
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              d="M6 6L18 18M18 6L6 18"
            ></path>
          </svg>
        </button>

        <div
          class="aura-review-modal__content"
          data-aura-review-modal-content
        ></div>
      </div>
    `;

    document.body.appendChild(
      modal
    );

    modal.addEventListener(
      'click',
      event => {
        if (
          event.target.closest(
            '[data-aura-review-modal-close]'
          )
        ) {
          closeReviewModal();
        }
      }
    );

    return modal;
  }


  function createModalMedia(review) {
    const pictures =
      Array.isArray(review.pictures)
        ? review.pictures
        : [];

    if (!pictures.length) {
      return null;
    }

    const media = createElement(
      'div',
      'aura-review-modal__media'
    );

    media.classList.add(
      pictures.length === 1
        ? 'aura-review-modal__media--single'
        : 'aura-review-modal__media--multiple'
    );

    pictures.forEach(
      picture => {
        const source = safeImageUrl(
          picture.large ||
          picture.original ||
          picture.medium
        );

        if (!source) {
          return;
        }

        const link = createElement(
          'a',
          'aura-review-modal__media-item'
        );

        link.href =
          safeImageUrl(
            picture.original ||
            picture.large
          ) || source;

        link.target =
          '_blank';

        link.rel =
          'noopener';

        const image =
          document.createElement('img');

        image.src =
          source;

        image.alt = review.title
          ? smartTitleCase(
              review.title
            )
          : 'Customer review photo';

        image.loading =
          'lazy';

        link.appendChild(
          image
        );

        media.appendChild(
          link
        );
      }
    );

    return media;
  }


  function renderReviewModal(review) {
    const modal =
      createReviewModal();

    const content =
      modal.querySelector(
        '[data-aura-review-modal-content]'
      );

    const dialog =
      modal.querySelector(
        '.aura-review-modal__dialog'
      );

    content.replaceChildren();

    dialog.classList.remove(
      'aura-review-modal__dialog--single-media',
      'aura-review-modal__dialog--multi-media',
      'aura-review-modal__dialog--no-media'
    );

    const pictures =
      Array.isArray(review.pictures)
        ? review.pictures
        : [];

    if (pictures.length === 1) {
      dialog.classList.add(
        'aura-review-modal__dialog--single-media'
      );

    } else if (
      pictures.length > 1
    ) {
      dialog.classList.add(
        'aura-review-modal__dialog--multi-media'
      );

    } else {
      dialog.classList.add(
        'aura-review-modal__dialog--no-media'
      );
    }

    const main = createElement(
      'div',
      'aura-review-modal__main'
    );

    const header = createElement(
      'div',
      'aura-review-modal__header'
    );

    const identity = createElement(
      'div',
      'aura-review-modal__identity'
    );

    identity.appendChild(
      createAvatar(review)
    );

    const person = createElement(
      'div',
      'aura-review-modal__person'
    );

    const nameRow = createElement(
      'div',
      'aura-review-modal__name-row'
    );

    nameRow.appendChild(
      createElement(
        'strong',
        'aura-review-modal__name',
        titleCaseName(
          review?.reviewer?.name ||
          'Anonymous'
        )
      )
    );

    if (review.verified) {
      nameRow.appendChild(
        createVerifiedBadge(
review.verification_label ||
          'Verified Buyer'
        )
      );
    }

    person.appendChild(
      nameRow
    );

    identity.appendChild(
      person
    );

    header.appendChild(
      identity
    );

    const date =
      formatDate(
        review.created_at
      );

    if (date) {
      const time = createElement(
        'time',
        'aura-review-modal__date',
        date
      );

      time.dateTime =
        review.created_at;

      header.appendChild(
        time
      );
    }

    main.appendChild(
      header
    );

    const modalStars =
      createStars(
        Math.round(
          Number(review.rating) || 0
        )
      );

    modalStars.classList.add(
      'aura-review-modal__stars'
    );

    main.appendChild(
      modalStars
    );

    if (review.title) {
      const title = createElement(
        'h2',
        'aura-review-modal__title',
        smartTitleCase(
          review.title
        )
      );

      title.id =
        'AuraReviewModalTitle';

      main.appendChild(
        title
      );

    } else {
      const title = createElement(
        'h2',
        'aura-review-modal__title aura-review-modal__title--visually-hidden',
        'Customer review'
      );

      title.id =
        'AuraReviewModalTitle';

      main.appendChild(
        title
      );
    }

    if (review.body) {
      main.appendChild(
        createElement(
          'p',
          'aura-review-modal__body',
          review.body
        )
      );
    }

    const productRow =
      createProductRow(
        review
      );

    if (productRow) {
      productRow.classList.add(
        'aura-review-modal__product'
      );

      main.appendChild(
        productRow
      );
    }

    content.appendChild(
      main
    );

    const media =
      createModalMedia(
        review
      );

    if (media) {
      content.appendChild(
        media
      );
    }

    return modal;
  }


  function openReviewModal(
    review,
    trigger
  ) {
    const modal =
      renderReviewModal(
        review
      );

    auraReviewLastFocus =
      trigger ||
      document.activeElement;

    modal.hidden =
      false;

    document.body.classList.add(
      'aura-review-modal-open'
    );

    requestAnimationFrame(
      () => {
        modal.classList.add(
          'aura-review-modal--open'
        );

        modal
          .querySelector(
            '.aura-review-modal__dialog'
          )
          ?.focus();
      }
    );
  }


  function closeReviewModal() {
    const modal =
      document.querySelector(
        '[data-aura-review-modal]'
      );

    if (!modal) {
      return;
    }

    modal.classList.remove(
      'aura-review-modal--open'
    );

    document.body.classList.remove(
      'aura-review-modal-open'
    );

    setTimeout(
      () => {
        modal.hidden =
          true;

        if (
          auraReviewLastFocus &&
          typeof auraReviewLastFocus.focus ===
            'function'
        ) {
          auraReviewLastFocus.focus();
        }
      },
      180
    );
  }


  document.addEventListener(
    'keydown',
    event => {
      if (
        event.key === 'Escape' &&
        document.querySelector(
          '.aura-review-modal--open'
        )
      ) {
        closeReviewModal();
      }
    }
  );


  /* =======================================================
     CREATE REVIEW CARD
     ======================================================= */

  function createReviewCard(review) {
    const card = createElement(
      'article',
      'aura-api-review'
    );

    const reviewerName =
      titleCaseName(
        review?.reviewer?.name ||
        'Anonymous'
      );

    card.tabIndex =
      0;

    card.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    card.setAttribute(
      'aria-label',
      `Read full review by ${reviewerName}`
    );

    card.addEventListener(
      'click',
      event => {
        if (
          event.target.closest(
            '.aura-api-review__product'
          )
        ) {
          return;
        }

        openReviewModal(
          review,
          card
        );
      }
    );

    card.addEventListener(
      'keydown',
      event => {
        if (
          event.key !== 'Enter' &&
          event.key !== ' '
        ) {
          return;
        }

        if (
          event.target.closest(
            '.aura-api-review__product'
          )
        ) {
          return;
        }

        event.preventDefault();

        openReviewModal(
          review,
          card
        );
      }
    );

    const pictures =
      Array.isArray(review.pictures)
        ? review.pictures
        : [];

    if (pictures.length === 1) {
      card.classList.add(
        'aura-api-review--single-media'
      );

    } else if (
      pictures.length > 1
    ) {
      card.classList.add(
        'aura-api-review--multi-media'
      );

    } else {
      card.classList.add(
        'aura-api-review--no-media'
      );
    }

    const header = createElement(
      'div',
      'aura-api-review__header'
    );

    const identity = createElement(
      'div',
      'aura-api-review__identity'
    );

    identity.appendChild(
      createAvatar(review)
    );

    const person = createElement(
      'div',
      'aura-api-review__person'
    );

    const personTop = createElement(
      'div',
      'aura-api-review__person-top'
    );

    const name = createElement(
      'strong',
      'aura-api-review__name',
      reviewerName
    );

    personTop.appendChild(
      name
    );

    if (review.verified) {
      personTop.appendChild(
        createVerifiedBadge(
review.verification_label ||
          'Verified Buyer'
        )
      );
    }

    person.appendChild(
      personTop
    );

    identity.appendChild(
      person
    );

    header.appendChild(
      identity
    );

    const date =
      formatDate(
        review.created_at
      );

    if (date) {
      const time = createElement(
        'time',
        'aura-api-review__date',
        date
      );

      time.dateTime =
        review.created_at;

      header.appendChild(
        time
      );
    }

    card.appendChild(
      header
    );

    card.appendChild(
      createStars(
        Math.round(
          Number(review.rating) || 0
        )
      )
    );

    const copy = createElement(
      'div',
      'aura-api-review__copy'
    );

    if (review.title) {
      copy.appendChild(
        createElement(
          'h3',
          'aura-api-review__title',
          smartTitleCase(
            review.title
          )
        )
      );
    }

    if (review.body) {
      copy.appendChild(
        createElement(
          'p',
          'aura-api-review__body',
          review.body
        )
      );
    }

    card.appendChild(
      copy
    );

    const media =
      createMedia(
        review
      );

    if (media) {
      card.appendChild(
        media
      );
    }

    const productRow =
      createProductRow(
        review
      );

    if (productRow) {
      card.appendChild(
        productRow
      );
    }

    return card;
  }


  /* =======================================================
     SKELETON
     ======================================================= */

  function createSkeleton() {
    const card = createElement(
      'div',
      'aura-api-review aura-api-review--skeleton'
    );

    card.innerHTML = `
      <div class="aura-review-skeleton aura-review-skeleton--header"></div>
      <div class="aura-review-skeleton aura-review-skeleton--stars"></div>
      <div class="aura-review-skeleton aura-review-skeleton--title"></div>
      <div class="aura-review-skeleton aura-review-skeleton--body"></div>
      <div class="aura-review-skeleton aura-review-skeleton--body aura-review-skeleton--short"></div>
    `;

    return card;
  }


  /* =======================================================
     FEED CONTROLLER
     ======================================================= */

  class AuraReviewsFeed {
    constructor(root) {
      this.root =
        root;

      this.endpoint =
        root.dataset.endpoint ||
        '';

      this.perPage =
        Number(
          root.dataset.perPage
        ) || 9;

      this.grid =
        root.querySelector(
          '[data-review-grid]'
        );

      this.status =
        root.querySelector(
          '[data-review-status]'
        );

      this.loadMore =
        root.querySelector(
          '[data-review-load-more]'
        );

      this.filters =
        Array.from(
          root.querySelectorAll(
            '[data-review-filter]'
          )
        );

this.handle =
        root.dataset.productHandle ||
        '';

      this.page =
        1;

      this.loading =
        false;

      this.bindEvents();

      this.loadReviews(
        true
      );
    }


    bindEvents() {
      this.filters.forEach(
        button => {
          button.addEventListener(
            'click',
            () => {
              const handle =
                button.dataset.productHandle ||
                '';

              if (
                handle === this.handle &&
                button.getAttribute(
                  'aria-pressed'
                ) === 'true'
              ) {
                return;
              }

              this.filters.forEach(
                filter => {
                  const active =
                    filter === button;

                  filter.classList.toggle(
                    'aura-reviews-products__pill--active',
                    active
                  );

                  filter.setAttribute(
                    'aria-pressed',
                    active
                      ? 'true'
                      : 'false'
                  );
                }
              );

              this.handle =
                handle;

              this.page =
                1;

              this.loadReviews(
                true
              );
            }
          );
        }
      );

      this.loadMore.addEventListener(
        'click',
        () => {
          this.page +=
            1;

          this.loadReviews(
            false
          );
        }
      );
    }


    showSkeletons() {
      this.grid.replaceChildren();

      for (
        let index = 0;
        index < 3;
        index += 1
      ) {
        this.grid.appendChild(
          createSkeleton()
        );
      }
    }


    async loadReviews(reset) {
      if (this.loading) {
        return;
      }

      if (!this.endpoint) {
        this.status.textContent =
          'Reviews API URL has not been configured.';

        return;
      }

      this.loading =
        true;

      this.status.textContent =
        '';

      this.loadMore.hidden =
        true;

      if (reset) {
        this.showSkeletons();

      } else {
        this.loadMore.textContent =
          'Loading…';

        this.loadMore.disabled =
          true;
      }

      try {
        const url =
          new URL(
            this.endpoint,
            window.location.origin
          );

        url.searchParams.set(
          'page',
          String(this.page)
        );

        url.searchParams.set(
          'per_page',
          String(this.perPage)
        );

        if (this.handle) {
          url.searchParams.set(
            'handle',
            this.handle
          );
        }

        const response =
          await fetch(
            url.toString(),
            {
              headers: {
                Accept:
                  'application/json'
              }
            }
          );

        if (!response.ok) {
          throw new Error(
            `Reviews request failed: ${response.status}`
          );
        }

        const data =
          await response.json();

        const reviews =
          Array.isArray(
            data.reviews
          )
            ? data.reviews
            : [];

        if (reset) {
          this.grid.replaceChildren();
        }

        reviews.forEach(
          review => {
            this.grid.appendChild(
              createReviewCard(
                review
              )
            );
          }
        );

        if (
          reset &&
          reviews.length === 0
        ) {
          this.status.textContent =
            'No reviews found for this product.';
        }

        this.loadMore.hidden =
          !data.has_more;

      } catch (error) {
        console.error(
          'Aura Reviews:',
          error
        );

        if (reset) {
          this.grid.replaceChildren();
        }

        this.status.textContent =
          'Reviews could not be loaded right now. Please try again.';

      } finally {
        this.loading =
          false;

        this.loadMore.disabled =
          false;

        this.loadMore.textContent =
          'Load more reviews';
      }
    }
  }


   /* =======================================================
     INITIALIZE
     Supports optional lazy loading with:
     data-lazy="true"
     ======================================================= */

  function startFeed(root) {
    if (
      root.dataset.auraReviewsReady ===
      'true'
    ) {
      return;
    }

    root.dataset.auraReviewsReady =
      'true';

    delete root.dataset.auraReviewsObserved;

    new AuraReviewsFeed(
      root
    );
  }


  function observeFeed(root) {
    if (
      root.dataset.auraReviewsReady ===
        'true' ||
      root.dataset.auraReviewsObserved ===
        'true'
    ) {
      return;
    }

    if (
      !(
        'IntersectionObserver'
        in window
      )
    ) {
      startFeed(root);
      return;
    }

    root.dataset.auraReviewsObserved =
      'true';

    const observer =
      new IntersectionObserver(
        entries => {
          const visible =
            entries.some(
              entry =>
                entry.isIntersecting
            );

          if (!visible) {
            return;
          }

          observer.disconnect();

          startFeed(root);
        },
        {
rootMargin:
  '200px 0px 200px 0px'
        }
      );

    observer.observe(root);
  }


  function init() {
    formatReviewCounts();

    document
      .querySelectorAll(
        '[data-aura-reviews-feed]'
      )
      .forEach(root => {
        const lazy =
          root.dataset.lazy ===
          'true';

        if (lazy) {
          observeFeed(root);
        } else {
          startFeed(root);
        }
      });
  }


  document.addEventListener(
    'DOMContentLoaded',
    init
  );


  document.addEventListener(
    'shopify:section:load',
    event => {
      const root =
        event.target.matches?.(
          '[data-aura-reviews-feed]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-aura-reviews-feed]'
            );

      if (root) {
        delete root.dataset.auraReviewsReady;
        delete root.dataset.auraReviewsObserved;
      }

      init();
    }
  );
})();